module.exports = __webpack_public_path__ + "img/薤白.a3966fc6.jpg";